import verInfo from './metadata.json';
export * from './localstorage';
export const BASE_URL = window.runConfig.BaseURL;
export const UserDataKey = window.runConfig.Keys.UserData;
export const PHONE_NUMBER_PREFIX = '+1';

export const versionInfo: { Version: string; ReleaseDate: string } = verInfo;

export const removePhoneNumberPrefix = (phoneNumber: string) =>
  phoneNumber.replace(PHONE_NUMBER_PREFIX, '');

export const addPhoneNumberPrefix = (phoneNumber: string) =>
  PHONE_NUMBER_PREFIX.concat(removePhoneNumberPrefix(phoneNumber));

export const dateFormat = (date: string) => {
  const mL = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December'
  ];
  const mS = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'June',
    'July',
    'Aug',
    'Sept',
    'Oct',
    'Nov',
    'Dec'
  ];
  const dL = [
    'Sunday',
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday'
  ];
  const dS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

  const tempDate = new Date(date);

  const dI = tempDate.getDay();
  const mI = tempDate.getMonth();
  const day = tempDate.getDate();
  const fullYears = tempDate.getFullYear();

  return `${dS[dI]} ${mS[mI]} ${day}, ${fullYears}`
};
